document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.add-to-cart-form').forEach(form => {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
  
        const formData = new FormData(form);
        const variantId = formData.get('id');
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
          .then(res => res.json())
          .then(() => fetch('/cart.js'))
          .then(res => res.json())
          .then(cart => {
            aggiornaContatoreCarrello(cart);
            showAddToCartToast();
            animaIconaCarrello(); 

          })
          .catch(error => {
            console.error('Errore nell’aggiunta al carrello:', error);
          });
      });
    });
  });
  
  function aggiornaContatoreCarrello(cart) {
    const bubble = document.querySelector('.cart-count-bubble');
    if (bubble) {
      const visibleCount = bubble.querySelector('span[aria-hidden="true"]');
      const hiddenCount = bubble.querySelector('.visually-hidden');
  
      if (visibleCount) visibleCount.textContent = cart.item_count;
      if (hiddenCount) hiddenCount.textContent = `${cart.item_count} items`;
  
      bubble.style.display = cart.item_count > 0 ? 'inline-block' : 'none';
    }
  }
  
  function showAddToCartToast() {
    const toast = document.getElementById('add-to-cart-toast');
    if (!toast) return;
  
    toast.style.display = 'block';
    setTimeout(() => {
      toast.style.opacity = 1;
    }, 10);
  
    setTimeout(() => {
      toast.style.opacity = 0;
      setTimeout(() => {
        toast.style.display = 'none';
      }, 800);
    }, 2500);
  }
  function formatMoney(cents) {
    return (cents / 100).toFixed(2) + ' €';
  }
  
  function caricaMiniCarrello() {
    const miniCart = document.getElementById('mini-cart');
    if (!miniCart) return;
  
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        if (cart.items.length === 0) {
          miniCart.innerHTML = '<p>Il carrello è vuoto.</p>';
        } else {
          let html = '<ul style="list-style:none;padding:0;margin:0;">';
          cart.items.forEach(item => {
            html += `
              <li style="display:flex;gap:10px;margin-bottom:10px;">
                <img src="${item.image}" alt="${item.product_title}" style="width:50px;height:auto;">
                <div>
                  <strong>${item.product_title}</strong><br>
                  Q.tà: ${item.quantity}<br>
                  ${formatMoney(item.price)}
                </div>
              </li>`;
          });
          html += '</ul>';
          miniCart.innerHTML = html;
        }
      });
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    const cartWrapper = document.querySelector('.cart-icon-wrapper');
    const miniCart = document.getElementById('mini-cart');
  
    if (cartWrapper && miniCart) {
      cartWrapper.addEventListener('mouseenter', () => {
        caricaMiniCarrello();
        miniCart.style.display = 'block';
      });
  
      cartWrapper.addEventListener('mouseleave', () => {
        miniCart.style.display = 'none';
      });
    }
  });
  function showAddToCartToast() {
    const toast = document.getElementById('add-to-cart-toast');
    if (!toast) return;
  
    toast.style.display = 'block';
    setTimeout(() => { toast.style.opacity = 1 }, 10);
  
    setTimeout(() => {
      toast.style.opacity = 0;
      setTimeout(() => {
        toast.style.display = 'none';
      }, 800);
    }, 2500);
  }
  
  function animaIconaCarrello() {
    const wrapper = document.querySelector('.cart-icon-wrapper');
    if (!wrapper) return;
  
    wrapper.classList.add('animate');
    setTimeout(() => wrapper.classList.remove('animate'), 800);
  }
  

  function aggiornaSelezioneVariante(productId, selectedId) {
    console.log('Aggiorna selezione variante:', productId, selectedId);
    const thumbnails = document.querySelectorAll(`.add-to-cart-form[data-product-id="${productId}"] .variant-thumbnail`);
    thumbnails.forEach(img => {
      if (img.dataset.variantId === selectedId) {
        img.classList.add('selected');
      } else {
        img.classList.remove('selected');
      }
    });
  }
  